import { useState } from "react";

const faqs = [
  {
    q: "吃瓜视频网是干什么的？",
    a: "吃瓜视频网是一个主打围观现场与弹幕互动的娱乐热点视频平台，汇聚综艺名场面、影视吐槽、社会热点等内容。你可以边看视频边发弹幕、参与评论热议和话题讨论，和全网吃瓜群众一起边看边聊。",
  },
  {
    q: "需要注册登录才能看视频和发弹幕吗？",
    a: "看视频、围观热门现场无需注册即可直接观看。发弹幕和参与话题评论目前也保持低门槛，注册后可以同步自己的点赞、收藏和讨论记录，让围观体验更连贯。",
  },
  {
    q: "弹幕互动是怎么玩的？",
    a: "在弹幕现场播放视频时，输入框里打一句话点发送，就会以彩色弹幕的形式从屏幕上飘过。系统会自动安排弹幕的轨道和速度，你也可以在评论区继续讨论，形成热闹的第二现场。",
  },
  {
    q: "话题广场里的热度是怎么来的？",
    a: "话题热度综合了围观人数、弹幕量、评论数与分享次数，实时计算并更新。参与人数越多的讨论，排名越靠前，方便你快速找到当下最热闹的瓜。",
  },
  {
    q: "会不会有审核和内容规范？",
    a: "会。为保证友善的围观氛围，站内实行内容与评论审核，禁止人身攻击、造谣和不良信息。我们鼓励理性吃瓜、文明吐槽，让讨论更健康。",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-accent-600 font-heading text-sm mb-1">FAQ</p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-600">关于吃瓜视频网，你可能想了解的都在这里</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className="card-lift rounded-xl overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="w-full flex items-center justify-between gap-3 text-left px-4 md:px-5 py-4 hover:bg-background-100 transition-colors"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                {open && (
                  <div className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed animate-pop-in">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}